// extracted by mini-css-extract-plugin
export default {"profile-img":"style_profile-img__xCZUx"};